import { type FC } from 'react'
import { passkeyService } from '@egw/auth'
import { VerifyPhoneOtp } from '../../../components/verify-phone-otp/verify-phone-otp'
import { VerifyPhoneLink } from '../../../components/verify-phone-link/verify-phone-link'

export const VerifyPhonePage: FC = () => {
  const isMobile = passkeyService.getIsMobile()

  if (!isMobile) {
    return <VerifyPhoneOtp />
  }

  return <VerifyPhoneLink />
}
